module.exports = __webpack_public_path__ + "media/images/icons/copywriting-4a4d36aab17aea9a682a8e9fbc4fa0c0.svg";